export const PRE_SESSION_PROMPT_CTA_INTRO_TEXT =
  "In the meantime, take a moment to...";
export const VIBES_CTA_BUTTON_TEXT = "Unwind while you wait";
export const CHECK_IN_CTA_BUTTON_TEXT = "Check in with your mood";
export const REFLECTION_TOPICS_CTA_BUTTON_TEXT =
  "Review topics for today’s session";
export const MEASURES_CTA_INTRO_TEXT =
  "These short surveys help your provider better understand how you’ve been doing.";
export const MEASURES_CTA_BUTTON_TEXT = "Start check-in";
